<template>
  <div class="huadoswip">
    <div class="rmlabt">合肥热门律师<span>三大认证保护，信赖之选！</span></div>
    <div class="hdlblist">
      <swiper ref="mySwiper" v-bind:options="swiperOptions" class='flex between'>
        <swiper-slide v-for="(item, index) in 4" v-bind:key="index">
          <div class="hdlbitem">
            <div class="mc">张三<span>律师</span></div>
            <div class="sjj"><span>家庭纠纷</span><span>土地纠纷</span></div>
            <div class="FontSize12 FontGray1"><svg-icon icon-class="dianhua" /> 123456789</div>
            <div class="rwtx">
              <img src="../../../assets/telzx/aaaa1.png" alt="" />
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.huadoswip {
  width: 100%;
  .rmlabt {
    font-size: 22px;
    color: #333333;
    font-weight: bold;
    span {
      font-size: 14px;
      color: #999999;
      margin-left: 20px;
      font-weight: 400;
    }
  }
  .hdlblist {
    margin-top: 20px;
    .hdlbitem {
		width: 200px;
		
      padding: 20px 15px;
      position: relative;
      height: 120px;
      background: #f5f5fa;
      box-shadow: 1px 1px 13px 0px rgba(0, 0, 0, 0.14);
      .mc {
        font-size: 18px;
        color: #333333;
        span {
          margin-left: 8px;
          font-size: 12px;
          color: #999999;
        }
      }
      .sjj {
        margin: 10px 0;
        font-size: 12px;
        color: #666666;
        span {
          margin-right: 5px;
        }
      }
      .rwtx {
        position: absolute;
        bottom: 0;
        right: 0;
        img {
          width: 100px;
          height: 115px;
        }
      }
    }
  }
}
</style>